import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkboxIndeterminate",
  "use": "checkboxIndeterminate-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkboxIndeterminate\">\n  <rect width=\"22\" height=\"22\" rx=\"4\" fill=\"#007770\" />\n  <rect x=\"0.5\" y=\"0.5\" width=\"21\" height=\"21\" rx=\"3.5\" stroke=\"#211F1D\" stroke-opacity=\"0.1\" />\n  <rect style=\"stroke: rgb(255, 255, 255); stroke-width: 2px;\" height=\"0.029\" x=\"5.986\" y=\"10.563\" width=\"10.984\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol